import { FC, useEffect } from 'react';
import cn from 'classnames';
import ls from 'localstorage-slim';

import { BGHoverComponent } from '../BGHoverComponent/BGHoverComponent';
import { togglePage } from '../../helpers/togglePage';
import { MenuItems } from '../../types/MenuItems';
import { CloseBtn } from '../CloseBtn/CloseBtn';
import { isSixInHash } from '../../helpers/isSixInHash';

import './SixSectionWrapper.scss';
import { getTranslation } from '../../constants/translations';

type Props = {
  title: string;
  textContent: string;
  id: string;
  color: string;
  imgURL: string;
};

export const SixSectionWrapper: FC<Props> = ({
  id,
  color,
  title,
  textContent,
  imgURL,
}) => {
  const { hash } = window.location;
  const theme = hash.split('-')[0].slice(1);

  const t = getTranslation();

  useEffect(() => {
    if (!hash.includes(`${id}`)) {
      window.setTimeout(() => {
        ls.remove('prevSixSection');
      }, 690);
    }
  }, [hash]);

  return (
    <div
      className={cn('six-section-wrapper', {
        'six-page-animation--page-open': hash.includes(`${id}`),
        'six-page-animation--page-close': !hash.includes(`${id}`),
        'six-section-wrapper__prev-opened':
          isSixInHash() && `${ls.get('prevSixSection')}`.includes(`${id}`),
      })}
      style={{
        transitionDelay: `${hash !== '#' + id ? '0.69s' : '0s'}`,
      }}
      id={id}
    >
      <div
        className={cn(`six-section-wrapper__support-bg ${theme}-bg`, {
          'six-page-animation__bg-open': hash.includes(`${id}`),
          'six-page-animation__bg-close':
            `${ls.get('prevSixSection')}`.includes(hash.slice(1)),
        })}
      >
        <BGHoverComponent conteinerWidth={window.screen.width} />
      </div>
      <article className="six-section-wrapper__content-part">
        <CloseBtn
          customClassName={`six-section-wrapper__close ${theme}-color`}
        />

        <div className="six-section-wrapper__content">
          <h3 className="six-section-wrapper__title">{title}</h3>

          <p className="six-section-wrapper__text">{textContent}</p>
        </div>
      </article>

      <div
        className="six-section-wrapper__color-part"
        style={{ backgroundColor: color }}
      >
        <BGHoverComponent />

        <button
          className="six-section-wrapper__start-btn-desktop menu-button"
          onClick={() => togglePage(`#${MenuItems.REGISTER}`)}
        >
          <span>{t.REGISTER['I want to start']}</span>
        </button>

        <button
          className="six-section-wrapper__start-btn-mobile"
          onClick={() => togglePage(`#${MenuItems.REGISTER}`)}
        >
          <span>{t.REGISTER.Begin}</span>
        </button>

        <div className="six-section-wrapper__image-container">
          <img className="six-section-wrapper__image" src={imgURL} alt={id} />
        </div>
      </div>
    </div>
  );
};
